import { useQuery } from '@tanstack/react-query'
import { api } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'
import type { Profile, ProfileResponse, PromptPreview } from '@/shared/api/types'

export const profileApi = {
  get: (signal?: AbortSignal) => api.get<ProfileResponse>('/profile', signal),
  save: (body: Profile) => api.put<ProfileResponse>('/profile', body),
  preview: (signal?: AbortSignal) => api.get<PromptPreview>('/prompt/preview', signal),
}

export function useProfile() {
  return useQuery({
    queryKey: queryKeys.profile,
    queryFn: ({ signal }) => profileApi.get(signal),
  })
}

/**
 * Собранный промпт: то, что реально услышит собеседник.
 *
 * Отдельный запрос, а не сборка на клиенте. Промпт клеит Go из тех же
 * данных, что уходят агенту; повтори мы эту сборку в браузере — рано
 * или поздно предпросмотр разошёлся бы с тем, что агент говорит на самом
 * деле, и это худший вид расхождения: незаметный.
 */
export function usePromptPreview(enabled = true) {
  return useQuery({
    queryKey: queryKeys.promptPreview,
    queryFn: ({ signal }) => profileApi.preview(signal),
    enabled,
  })
}
